const trainHeroicBrandVariables = {
    colors: {
        textPrimary: '#050310de',
        textSecondary: '#05031099',
        textDisabled: '#05031061',
        textPrimaryShades4p: '#050310a',
        textPrimaryShades12p: '#0503101f',
        textPrimaryShades30p: '#0503104d',
        textSecondaryShades4p: '#050310a',
        textSecondaryShades18p: '#0503102e',
        primaryMain: '#0A0EFF',
        primaryDark: '#0003CA',
        primaryLight: '#EEF4FF',
        primaryContrast: '#FFFFFF',
        primaryShades8p: '#C2C2C214',
        primaryShades12p: '#C2C2C21f',
        primaryShades30p: '#C2C2C24d',
        primaryShades50p: '#C2C2C280',
        secondaryMain: '#120B3B',
        secondaryDark: '#050310',
        secondaryLight: '#58565F',
        secondaryContrast: '#FFFFFF',
        secondaryShades8p: '#C2C2C214',
        secondaryShades12p: '#C2C2C21f',
        secondaryShades30p: '#C2C2C24d',
        secondaryShades50p: '#C2C2C280',
        actionActive: '#0503108a',
        actionHover: 'rgba(5, 3, 16, 0.04)',
        actionSelected: '#05031014',
        actionDisabled: '#05031042',
        actionDisabledBackground: '#0503101f',
        actionFocus: '#0503101f',
        actionShades30p: '#0503104d',
        errorMain: '#D32F2F',
        errorDark: '#C62828',
        errorLight: '#EF5350',
        errorContrast: '#FFFFFF',
        errorShades12p: '#D32F2F1f',
        errorShades30p: '#D32F2F4d',
        errorShades50p: '#D32F2F80',
        warningMain: '#ED6C02',
        warningDark: '#E65100',
        warningLight: '#FF9800',
        warningContrast: '#FFFFFF',
        warningShades12p: '#ED6C021f',
        warningShades30p: '#ED6C024d',
        warningShades50p: '#ED6C0280',
        infoMain: '#0288D1',
        infoDark: '#01579B',
        infoLight: '#03A9F4',
        infoContrast: '#FFFFFF',
        infoShades12p: '#0288D11f',
        infoShades30p: '#0288D14d',
        infoShades50p: '#0288D180',
        successMain: '#2E7D32',
        successDark: '#1B5E20',
        successContrast: '#FFFFFF',
        successLight: '#4CAF50',
        successShades12p: '#2E7D321f',
        successShades30p: '#2E7D324d',
        successShades50p: '#2E7D3280',
        backgroundPaper: '#FFFFFF',
        backgroundDefault: '#FAFAFA',
        otherDivider: '#0503101f',
        otherOutlinedBorder: '#0503103b',
        otherFilledInputBackground: '#050310f',
        otherStandardInputLine: '#0503106b',
        otherSnackbar: '#323232',
        otherRatingActive: '#FFB400',
        black100p: '#000000',
        white30p: '#FFFFFF4d',
        white100p: '#FFFFFF'
    }
};

export default trainHeroicBrandVariables;
